import { jsx as _jsx } from "react/jsx-runtime";
export const KSpace = ({ className, spaces = 1, v = false }) => {
    return v ? _jsx("div", { className: className, style: { display: "inline-block", width: 15 * spaces } }) : _jsx("div", { className: className, style: { display: "block", height: 15 * spaces } });
};
